import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { centerable as n } from "../decorators/centerable.js";
import { uploadable as r } from "../decorators/uploadable.js";
import "../decorators.js";
var i = n(r({
	inline: !1,
	draggable: !0,
	attrs: t({
		type: { default: "audioFile" },
		url: { default: "" }
	}),
	group: "block",
	parseDOM: [{
		tag: ".intercom-interblocks-audio-file",
		getAttrs(e) {
			return { url: e.querySelector("audio")?.getAttribute("src") ?? "" };
		}
	}, {
		tag: ".embercom-prosemirror-composer-block-container.embercom-prosemirror-composer-audio audio",
		getAttrs(e) {
			return { url: e.querySelector("source")?.getAttribute("src") ?? "" };
		}
	}],
	toDOM(t) {
		let n = t.attrs;
		return [
			"div",
			{ class: `${e.blockContainer} ${e.audio}` },
			["audio", {
				class: "block-audio-file-player",
				controls: "",
				controlsList: "nodownload nofullscreen noremoteplayback noplaybackrate",
				src: n.url,
				style: "width: 100%;"
			}]
		];
	}
}));
//#endregion
export { i as audioFileSpec };
